import jet from "./defs";

import "./class/native/Number";
import "./class/native/*";

export default jet;